import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Query } from 'react-apollo';
import debounce from 'lodash.debounce';
import { withRouter } from 'react-router-dom';

import { StaticContext, Autocomplete } from '@sm/webassets';
import { defineMessages } from '@sm/intl';

import './search-box.scss';
import publishedApplicationListingsByKeywordQuery from './SearchBox.graphql';
import AppPlaceHolderImg from '../../static/images/app-placeholder.png';

const COPY = defineMessages({
  SEARCHBOX_PLACEHOLDER: {
    id: 'AppsDirectory.SearchBox.Placeholder',
    defaultMessage: 'Search the App Directory',
    description: '[Type: Label][Vis.: high] - A placeholder text for the search box indicating its intention',
  },
});

function mapItemsToAutocomplete({ publishedApplicationListingsByKeyword: { items } }) {
  return items.map(({ name: text, logo, id, links: { detail: link } }) => ({
    text,
    logo,
    id,
    link,
  }));
}

class SearchBox extends Component {
  constructor(props) {
    super(props);
    this.handleTermChanged = debounce(this.handleTermChanged, 500);
  }

  state = {
    keyword: '',
  };

  handleTermChanged = keyword => {
    this.setState({ keyword });
  };

  handleItemSelected = ({ link }) => {
    window.location.assign(link);
  };

  handleSubmit = keyword => {
    this.props.history.push(`/apps/search?q=${keyword}`);
  };

  render() {
    const { environment } = this.context;
    return (
      <Query
        query={publishedApplicationListingsByKeywordQuery}
        skip={!!this.state.keyword === false}
        variables={{
          language: environment.languageId,
          keyword: this.state.keyword,
        }}
      >
        {({ loading, error, data }) => {
          return (
            <Autocomplete
              className="sm-search-box"
              placeholder={COPY.SEARCHBOX_PLACEHOLDER.defaultMessage}
              onTextChanged={this.handleTermChanged}
              onItemSelected={this.handleItemSelected}
              onSubmit={this.handleSubmit}
              isLoading={loading}
              hasError={!!error && !!this.state.keyword}
              text={this.state.keyword}
              data={
                loading || (!!error && !!this.state.keyword) || this.state.keyword === ''
                  ? []
                  : mapItemsToAutocomplete(data)
              }
              renderItem={({ text, logo }) => (
                <div className="sm-search-box__item">
                  <img alt={text} className="sm-search-box__item-icon" src={logo || AppPlaceHolderImg} />
                  {text}
                </div>
              )}
            />
          );
        }}
      </Query>
    );
  }
}

SearchBox.propTypes = {
  history: PropTypes.shape({
    push: PropTypes.func.isRequired,
  }).isRequired,
};

export default withRouter(SearchBox);
SearchBox.contextType = StaticContext;
